import { MixedSchema } from 'yup/lib/mixed';

export default function pdf(this: MixedSchema, message: string) {
  const defaultMessage = `Arquivo inválido`;

  return this.test('pdf', message || defaultMessage, (value: File) => {
    return value?.type === 'application/pdf';
  });
}
